import React, {useState} from "react";
import withAPI from "../../services/api";

import ClosePopupBtn from "../UtilComps/ClosePopupBtn";
import "./LearnerResetPWModal.scss";

const LearnerResetPWModal = ({
  api,
  setPWFunc,
  shouldShowFunc,
  clsId,
  learnerId,
}) => {
  const [pw1, setPW1] = useState("");
  const [pw2, setPW2] = useState("");
  const [error, setError] = useState(null);

  const handleRename = () => {
    setError(null);

    if (pw1 === "" || pw2 === "") {
      setError("Password cannot be blank.");
      return;
    } else if (pw1 !== pw2) {
      setError("Passwords must match.");
      return;
    } else if (pw1.length < 4) {
      setError("Passwords must be at least 4 digits.");
      return;
    }

    api
      .patchLearnerInfo(learnerId, {student_pwd: pw1})
      .then(() => {
        setPWFunc(pw1);
        shouldShowFunc(false);
      })
      .catch(() => {
        setError("Something went wrong resetting learner's password.");
      });
  };
  return (
    <div className='pdf-upload'>
      <div className='pdf-upload-wrapper'>
        <div className='common_border'>
          <div className='common_heading'>
            <p>Set New Password</p>
            <ClosePopupBtn closePopupFunc={shouldShowFunc} />
          </div>
          <div className='reset_pw_modal common_dashboard_bg'>
            <div className='row'>
              <div className='col-12'>
                {error && <div className='alert alert-danger'>{error}</div>}
                <div className='form-content form-group'>
                  <h5>Please set a password (at least 4 digits).</h5>
                  <input
                    className='form-control'
                    type='password'
                    placeholder='Password'
                    autoComplete="new-password"
                    value={pw1}
                    onChange={(e) => setPW1(e.target.value)}
                  />
                  <input
                    className='form-control'
                    type='password'
                    placeholder='Password (Again)'
                    autoComplete="new-password"
                    value={pw2}
                    onChange={(e) => setPW2(e.target.value)}
                  />
                  <div>
                    <button
                      onClick={handleRename}
                      className='btn btn-lg fs-14 btn-primary col-md-5 form-control'
                    >
                      Set New Password
                    </button>
                  </div>
                </div>
                <div className='alert alert-warning'>
                  <span>
                    Note: Resetting the learner's password may affect other
                    teachers if the learner is in multiple classes.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAPI(LearnerResetPWModal);
